import React from 'react';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import './multiReport.css'
import { domain, partyBrands } from '../../common/config.js';
import { Link } from 'react-router-dom';
import ProgressBar from './../ReportCard/ProgressBar.js'
import moment from 'moment';
import Loading from '../Loading.js';
import queryString from 'query-string';
import { ReportCardFilter} from "mygame-components";
import OnBoard from '../MygameOnBoard/OnBoard'
import { updateOnBoard, trackSid, saveActivity } from '../../common/commonService'
import { getColor, getTextColor } from '../../common/ThemeService';
var _ = require('lodash')
import i18next from 'i18next'
class ReportCards extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = queryString.parse(this.props.location.search);
    this.state = {
      accountName: localStorage.getItem('accountName') && queryParams.logintype === 'player' ? localStorage.getItem('accountName') : queryParams.accountName,
      gameType: '',
      loading: false,
      open: false,
      loginRedirect: false,
      title: 'Skill Levels',
      isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
      access: JSON.parse(localStorage.getItem('userRole')),
      noHandsmedal: "//" + domain + "/images/Medals/notEnoughHands/cash.png",
      loggedInType: localStorage.getItem('loggedInType')
    }
    let reportCardSetting = []


    if (queryParams.logintype === 'player') {
      this.props.reportCardSetting.map((eachGameRepoSetting) => {
        if (eachGameRepoSetting.hitRange === 'Select') {
          if (queryParams.source && queryParams.source === 'mygamelive') eachGameRepoSetting.hitRange = 'Today'
          else eachGameRepoSetting.hitRange = 'This Year'
          eachGameRepoSetting.accountName = localStorage.getItem('accountName') ? localStorage.getItem('accountName') : queryString.parse(this.props.location.search).accountName,
            reportCardSetting.push(eachGameRepoSetting)
        } else {
          reportCardSetting.push(eachGameRepoSetting)
        }
      })
    } else {
      this.props.reportCardSetting.map((eachGameRepoSetting) => {
        if (eachGameRepoSetting.hitRange === 'Select') {
          reportCardSetting.push({
            ...eachGameRepoSetting,
            ...(queryParams)
          })
        }else{
          reportCardSetting.push({...eachGameRepoSetting})
        }
      })
    }
    if (reportCardSetting.filter((obj)=>obj.hitRange==='Select').length >0 || this.props.multiGamePlayerReports.length!=4) {
      this.props.getMultiReportCardDeatils(reportCardSetting)
    } else if (reportCardSetting.length === 1 && reportCardSetting[0].gameType != 'tournament') {
      this.props.getSingleReportCardsDetails(reportCardSetting[0])
    }
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    console.log("params, params.sId",params, params.sId)
    if(params && params.sId) {
      trackSid(params.sId, window.location.pathname)
    }
  }

  disableOnBoard = async () => {
    this.setState({ loading: true, isOnBoard: 0 })
    await updateOnBoard()
    this.setState({ loading: false })
  }

  openModal = (gameType) => {
    window.scrollTo(0, 0);
    this.setState({
      open: true,
      gameType: gameType
    })
    this.props.setGameType(gameType)
  }

  closeModal = () => {
    window.scrollTo(0, 0);
    this.setState({ open: false })
  }

  viewReports = async (plyReport) => {
    await this.props.setGameType(plyReport.gameType)
  }

  saveSettings = (values) => {
    let defaultReportSettings = {
      playerChangeFilter:true,
      accountName: this.state.accountName,
      rangeChange: false, range: 0, hitLevel: 'All Level',
      shift: "Select", hitType: '6-Seater',
      hitRange: localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1 ? 'This Year' : 'Select',
    },
      reportCardSetting = [],
      isReportSettingChange = _.isEqual(this.props.formData.reportCardSettingFilter.initial, this.props.formData.reportCardSettingFilter.values)

    if (!isReportSettingChange) {
      if (values.range == 'Select') delete values.range
      if (Object.keys(values).length > 0) {
        if (values.level) defaultReportSettings.hitLevel = values.level
        if (values.type) defaultReportSettings.hitType = values.type

        if (values.range) {
          defaultReportSettings.hitRange = values.range
          if (values.range == 'Today') {
            defaultReportSettings.fromDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
            defaultReportSettings.toDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
          }
        }
        this.props.reportCardSetting.map((eachGameRepoSetting) => {
          if (eachGameRepoSetting.gameType === this.state.gameType)
            reportCardSetting.push({ ...eachGameRepoSetting, ...defaultReportSettings })
          else if (eachGameRepoSetting.hitRange === 'Select' || localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') === -1)
            reportCardSetting.push({ ...eachGameRepoSetting })


        })
        if (reportCardSetting.length > 1) {
          this.props.getMultiReportCardDeatils(reportCardSetting)
        } else if (reportCardSetting.length === 1) {
          this.props.getSingleReportCardsDetails(reportCardSetting[0])
        }
      }
    }
    window.scrollTo(0, 0);
    this.setState({ open: false })
  }

  getReportCardQueryString = (logintype, hitLevel, hitRange, hitType, fromDate, toDate, shift) => {
    let queryObj = { hitRange, hitLevel, hitType };
    if (logintype === 'player')
      return queryString.stringify(queryObj)
    else
      return queryString.stringify({ ...queryObj, fromDate, toDate, shift })
  }
  render() {
    const themeColor = getColor();
    const themeTextColor = getTextColor();
    this.props.setHeaderTitle(this.state.title);
    let gameType = 'cash';
    let multiGamePlayerReports = [];
    if (this.props.multiGamePlayerReports.length > 0) {
      multiGamePlayerReports = this.props.multiGamePlayerReports.sort((a, b) => {
        if (!a.summaryInfo || a.summaryInfo.length === 0) {
          a.summaryInfo = [{ points: 0 }]
        }
        if (!b.summaryInfo || b.summaryInfo.length === 0) {
          b.summaryInfo = [{ points: 0 }]
        }
        if (b.summaryInfo[0].points == 0 && a.summaryInfo[0].points == 0)
          return b.hands - a.hands
        else
          return b.summaryInfo[0].points - a.summaryInfo[0].points
      })
    }
    const queryParams = queryString.parse(this.props.location.search);
    return (
      <div className="background" style={{backgroundImage: `url(https://${domain}/images/skillLevel/skill_level_bg_${localStorage.getItem("loggedInType") === "Danskespil"? "Danskespil" : "PartyPoker"}.jpg)`}}>
       {this.state.isOnBoard ==1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1  && <OnBoard  disableOnBoard={this.disableOnBoard}/>}
        <div className='container'>
          <div className="centerAlign">
            <div className="pageHeading">{i18next.t("lable.yourReportCard")}</div>
            {this.props.loading ? <Loading /> : null}
            {multiGamePlayerReports.length > 0 && !this.props.loading &&
              multiGamePlayerReports.map((plyReport, i) => {
                gameType = plyReport.gameType == 'tournament'
                  ? 'tournaments' : plyReport.gameType == 'spin' ? plyReport.gameType + ' game' :plyReport.gameType==='cash' ? 'NLH Cash Game' :plyReport.gameType === 'plo'? 'PLO Cash Game' : plyReport.gameType
                let  hitType =  plyReport.hitType=== '6-seater' ? '6 Max' : plyReport.hitType
                return (
                  <div key={`reportCard_${i}`} className='row repoCard'>
                    {this.state.open && this.state.gameType === plyReport.gameType &&
                      <ReportCardFilter
                        i18next={i18next}
                        open={this.state.open}
                        access={this.state.access}
                        levels={gameType != 'tournaments' ? plyReport.playerLevels : []}
                        medalUrl={plyReport.hands > 100 && plyReport.summaryInfo[0].medal && plyReport.star
                          ? `//${domain}/images/Medals/${partyBrands.includes(this.state.loggedInType)?`PartyPoker/${plyReport.gameType}`:plyReport.gameType}/${plyReport.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "")}/${plyReport.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "")}_${plyReport.star}.png`
                          : `//${domain}/images/Medals/${partyBrands.includes(this.state.loggedInType) ? `PartyPoker/notEnoughHands` : `notEnoughHands`}/${plyReport.gameType}.png`}
                          saveSettings={() => this.saveSettings}
                        closeFilter={() => this.setState({ open: false })}
                      />}

                    {plyReport.hands >= 100 ?
                      <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 medalWidth"
                        style={{ paddingRight: 0, paddingTop: '10px', paddingBottom: '10px', }}>
                        <center>
                          <img
                            data-e2e={plyReport.gameType.toLowerCase() + "Img"} src={plyReport.summaryInfo[0].medal && (`//${domain}/images/Medals/${partyBrands.includes(this.state.loggedInType)?`PartyPoker/${plyReport.gameType}`:plyReport.gameType}/${plyReport.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + plyReport.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "")}_${plyReport.star}.png`)} height='146px' width='146px' />
                        </center>
                      </div>
                      :
                      <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 medalWidth"
                        style={{ paddingTop: '22.72px', paddingRight: 0, textAlign: 'center' }}>
                        <ProgressBar
                          data={[Math.round(plyReport.hands? plyReport.hands : 0), 100 - Math.round(plyReport.hands? plyReport.hands : 0)]}
                          text={plyReport.hands? plyReport.hands : 0}
                          colors={[`${themeColor}`, '#DADADA']}
                        />
                        {/* <div className='row handsPlayed' style={{ margin: 0 }}>Hands Played</div> */}
                      </div>
                    }

                    <div className="col-xs-12 col-sm-9 col-md-8 col-lg-8 textAlignInMob" style={{ padding: 0 }}>
                      <div className='row cashText' style={{ margin: 0 }}>
                        {_.startCase(i18next.t("lable."+gameType))} 
                        {plyReport.hands >= 100
                          ?
                          <span>{i18next.t("lable.reportCard")}
                        <span className="displayMob">- </span>
                            <span className="levelFont" style={{ fontWeight: 'bold' }}>
                              <span className="displayMob"> {plyReport.summaryInfo[0].medal}</span>
                              <div style={{ fontSize: '16px', fontWeight: '400' }}>
                                {gameType == 'tournaments' ? `${i18next.t("lable."+plyReport.hitRange)}` : `${i18next.t("lable."+hitType)}, ${plyReport.hitLevel === "All Level" ? i18next.t("lable.allStakes") : plyReport.hitLevel}, ${i18next.t("lable."+plyReport.hitRange)}`}&nbsp;
                              </div>
                            </span>
                          </span>
                          :
                          <span> {i18next.t("lable.reportCard")}
                        <span className="displayMob">- </span>
                            <span className="levelFont" style={{ fontSize: '18px' }}>
                              {plyReport.gameType == 'cash' ?
                                ` ${i18next.t("lable."+hitType)}, ${plyReport.hitLevel === "All Level" ? i18next.t("lable.allStakes") : plyReport.hitLevel}, ${i18next.t("lable."+plyReport.hitRange)}`
                                : `${i18next.t("lable."+plyReport.hitRange)}`
                              }
                            </span>
                          </span>}
                        {plyReport.hands >= 100 ?
                          <div style={{ paddingTop: '15.83px' ,position:'relative'}}>
                            <Link
                              to={{
                                pathname: `/ReportCard/${this.state.accountName}/${plyReport.gameType}`,
                                search: `?${this.getReportCardQueryString(
                                  queryParams.logintype,
                                  plyReport.hitLevel,
                                  plyReport.hitRange,
                                  plyReport.hitType,
                                  queryParams.fromDate,
                                  queryParams.toDate,
                                  queryParams.shift
                                )}`,
                              }}
                            >
                              <button className='viewReport missionbtn' data-e2e={plyReport.gameType}
                                style={{
                                  backgroundColor: themeColor,
                                  color: themeTextColor,
                                }}                                
                                onClick={() => 
                                {
                                  saveActivity({
                                  hit_page: 'ReportCard',
                                  hit_type: 'ReportCard_viewReport',
                                  hit_attribute1: plyReport.gameType,
                                  hit_attribute2: plyReport.hitType,
                                  hit_attribute3: plyReport.hitRange,
                                  hit_attribute4: plyReport.hitLevel,
                                  hit_attribute5: plyReport.summaryInfo[0].medal,
                                  })
                                  this.viewReports(plyReport)
                                }
                                
                                } id="reportCardTest">
                                {i18next.t("lable.viewReport")}
                          </button>
                            </Link>
                            &nbsp;
                            <button className='missionbtn skillEditButton' onClick={() => this.openModal(plyReport.gameType)} style={{ float: 'none', 'backgroundColor': themeColor, position: 'absolute', height: '33px', bottom: 0 }}>
                              <i className="fa fa-filter"  style={{ color: themeTextColor, fontWeight: 'bolder' }}></i>
                            </button>
                          </div>
                          :
                          <span>
                            <div className='row skilhandLimitText'>
                            {i18next.t("lable.play100HandGeneratereport")}
                        </div>
                            <div className='row noteText'>
                              {/* {plyReport.gameType == 'cash'
                                ? <span>
                                  Please note only Fast Forward and Cash Game No Limit Hold Em hands are included
                                  in this Report - And HeadsUP or 3 handed play is excluded.
                             </span>
                                : <span>Only NLHE tournaments included</span>} */}
                            </div>
                            <div className='row skill-level-filter-button' style={{ margin: 0, padding: '0'}}>
                              <button className='missionbtn skillEditButton'
                                onClick={() => this.openModal(plyReport.gameType)}
                                style={{'backgroundColor': themeColor }}
                              >
                                <i className="fa fa-filter" style={{ color: themeTextColor }}data-e2e={plyReport.gameType+"EditSettings"}></i>
                              </button><span className="editSettingButton" 
                                style={{ paddingLeft: '10.02px', paddingTop: '10.02px' }}>
                                {i18next.t("lable.editSettings")}
                          </span>
                            </div>
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.commonReducer.loading,
    multiGamePlayerReports: state.multipleReportCards.multiGamePlayerReports,
    reportCardSetting: state.multipleReportCards.reportCardSetting,
    rangeList: state.multipleReportCards.rangeList,
    formData: state.form,
    lang: state.header.lang
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
    getMultiReportCardDeatils: (playeReoprtDtls) => dispatch(actions.getMultiReportCardDeatils(playeReoprtDtls)),
    getSingleReportCardsDetails: (reportCardSetting) => dispatch(actions.getSingleReportCardsDetails(reportCardSetting)),
    setGameType: (gameType) => dispatch(actions.setGameType(gameType)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportCards);
// export default (withTranslation(),connect(mapStateToProps, mapDispatchToProps))(ReportCards);



/** WEBPACK FOOTER **
 ** ./src/components/MultipleReportCards/ReportCards.js
 **/